import { render, staticRenderFns } from "./CamStreamsTab.vue?vue&type=template&id=2f3e0a3a&scoped=true"
import script from "./CamStreamsTab.vue?vue&type=script&lang=js"
export * from "./CamStreamsTab.vue?vue&type=script&lang=js"
import style0 from "./CamStreamsTab.vue?vue&type=style&index=0&id=2f3e0a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e0a3a",
  null
  
)

export default component.exports